import { ColumnsType } from 'antd/lib/table'
import {
  FilterOptions,
  FilterWithItems,
  FilterWithKey,
} from '../../../../../../CIMSColumn/types/filter'

export function filterByKey<T>({
  key,
  type,
}: WithKeyFilter<T>): ColumnsType<T>[number]['onFilter'] {
  return (value, record) => {
    const recordValue = record[key] as string | number | boolean
    if (recordValue === undefined || recordValue === null) return false
    if (type === 'search')
      return String(recordValue)
        .toLowerCase()
        .includes(String(value).toLowerCase())
    return recordValue === value
  }
}

type WithKeyFilter<T> = FilterOptions<T> &
  (FilterWithKey<T> | FilterWithItems<T>)
